export default "__VITE_ASSET__Vmy6He____ 100w";